<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
    width="500"
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title>
        <strong>ข้อมูลการเติมเงิน</strong>
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 540px" v-if="data != null">
        <div class="my-3 text-center">
          <h4>
            คุณ {{ data.user.firstname }} {{ data.user.lastname }} เติมเงินจำนวน
          </h4>
          <h1 class="green--text font-weight-bold">
            {{ data.amount | numFormat("0,0.00") }} บาท
          </h1>
          <div>{{ data.reference }}</div>

          <v-divider class="my-3"></v-divider>

          <div v-if="['waiting', 'accepted', 'rejected'].includes(data.status)">
            หลักฐานการชำระเงิน
            <div class="text-center">
              <v-img :src="data.media_url"></v-img>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions v-if="data != null">
        <v-spacer></v-spacer>
        <template v-if="data.status == 'waiting'">
          <v-btn depressed>ปฏิเสธ</v-btn>
          <v-btn depressed color="primary" @click="onSubmit('accepted')"
            >ยืนยัน</v-btn
          >
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from "@/services";
import { monthList } from "@/utils/Constants";
import moment from "moment";

export default {
  name: "deposit-dialog",
  props: {
    data: { default: null },
    showDialog: { default: false },
  },
  data() {
    return {
      loading: false,
      isPass: false,
      isError: false,
      list: [],
    };
  },
  computed: {
    show: {
      get() {
        if (this.showDialog) {
        }
        return this.showDialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    onSubmit(status) {
      let data = {
        reference: this.data.reference,
        status: status,
        meta: null,
      };

      Service.Wallet.update(data).then((res) => {
        if (res.success) {
          this.$emit("close");
        }
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
